import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { RootProviders } from './local'
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <RootProviders>
      <App />
    </RootProviders>
  </React.StrictMode>,
  document.getElementById('root')
)
